(function () {
  function setupPrintAddon(hostEl) {
    const root = hostEl; // <product-form> inside modal/page
    const scope = root.closest('product-info') || document;

    // base nodes
    const toggle = root.querySelector('#print-toggle');
    const basePriceEl = root.querySelector('#base-price');
    const addonPriceEl = root.querySelector('#addon-price');
    const totalEl = root.querySelector('#grand-total');

    // optional displays
    const baseQtyDisplay  = root.querySelector('[data-base-qty]');
    const baseSubtotalEl  = root.querySelector('[data-base-subtotal]');
    const addonQtyDisplay = root.querySelector('[data-addon-qty]');
    const addonSubtotalEl = root.querySelector('[data-addon-subtotal]');

    // repeater
    const repeater  = root.querySelector('#print-repeater');
    if (!repeater) {
      scope.__printRepeater = null;
      return;
    }

    const rowsEl    = repeater?.querySelector('.print-repeater__rows') || null;
    const tpl       = repeater?.querySelector('#print-row-template') || null;
    const addBtn    = repeater?.querySelector('[data-repeater-add]') || null;
    const printMode = repeater?.dataset.printMode || 'with_select';
    const sectionId = repeater?.dataset.sectionId || root.dataset.sectionId || '';

    // main qty (outside modal)
    const qtyInput = scope.querySelector('.quantity__input[name="quantity"]');

    // errors
    const errorWrap = root.querySelector('.product-form__error-message-wrapper');
    const errorText = root.querySelector('.product-form__error-message');
    const printRequiredMsg = root.dataset.printRequiredT || 'Please fill in print information.';
    const showError = (msg) => { if (!errorWrap||!errorText) return; errorText.textContent = msg || printRequiredMsg; errorWrap.hidden = false; };
    const hideError = () => { if (errorWrap) errorWrap.hidden = true; };

    // money
    const getCentsAttr = (el, key) => {
      if (!el) return 0;
      const v = parseInt(el.dataset[key] || '0', 10);
      return Number.isFinite(v) ? v : 0;
    };
    let moneyFormatter = (cents) =>
      (cents / 100).toLocaleString('nb-NO', { style: 'currency', currency: 'NOK', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const initializeFormatter = () => {
      if (typeof window !== 'undefined' && typeof window.money === 'function') {
        try { moneyFormatter = (cents) => window.money(cents); updateTotals(); } catch(_) {}
      }
    };
    (function pollMoney(){
      let i=0,t=setInterval(()=>{ if(typeof window!=='undefined'&&typeof window.money==='function'){clearInterval(t);initializeFormatter();} else if(i++>=60){clearInterval(t);} },50);
    })();
    initializeFormatter();

    // variants
    let variantData = [];
    try {
      const el = document.getElementById(`ProductVariants-${sectionId}`);
      if (el?.textContent) variantData = JSON.parse(el.textContent);
    } catch(e){ console.warn('[print-addon] Variant JSON parse error', e); }

    const findVariantById = (id) => variantData.find(v => String(v.id) === String(id)) || null;
    const getPriceById    = (id) => { const v=findVariantById(id); return typeof v?.price==='number' ? v.price : null; };
    const getSkuById      = (id) => (findVariantById(id)?.sku || '');

    const getVariantInput = () =>
      scope.querySelector('input.product-variant-id[name="id"]') || scope.querySelector('form input[name="id"]');

    const currentVariantId = () => {
      const el = getVariantInput();
      return el ? Number(el.value) : null;
    };

    const baseUnitCents = () => {
      const attr = getCentsAttr(basePriceEl, 'baseCents');
      if (attr > 0) return attr;
      const p = getPriceById(currentVariantId());
      return typeof p === 'number' ? p : 0;
    };
    const addonUnitCents = () => getCentsAttr(addonPriceEl, 'addonCents');

    // rows helpers
    const rows = () => rowsEl ? Array.from(rowsEl.querySelectorAll('[data-row]')) : [];
    const rowActiveTab = (row) => row.querySelector('.print-tab__button.print-tab__button--active')?.dataset.tab || 'custom';
    const getRowQty = (row) => {
      const el = row.querySelector('[data-qty]');
      const n = Math.max(1, parseInt(el?.value || '1', 10));
      return Number.isFinite(n) ? n : 1;
    };
    const setRowQty = (row, n) => {
      const el = row.querySelector('[data-qty]'); if (!el) return;
      el.value = String(Math.max(1, parseInt(n || '1', 10)));
    };

    // filled-state
    function rowHasContent(row){
      if (printMode === 'with_select') {
        const tab = rowActiveTab(row);
        if (tab === 'team') {
          return !!String(row.querySelector('[data-player]')?.value || '').trim();
        } else {
          const n  = String(row.querySelector('[data-print-number]')?.value || '').replace(/^0+(?=\d)/,'').trim();
          const nm = String(row.querySelector('[data-print-name]')?.value || '').trim();
          return n.length > 0 || nm.length > 0;
        }
      } else {
        return !!String(row.querySelector('[data-print-free]')?.value || '').trim();
      }
    }

    // sums & limits
    const selectedQty  = () => { const q = Math.max(1, parseInt(qtyInput?.value || '1', 10)); return Number.isFinite(q) ? q : 1; };
    const sumAllRowQty = () => rows().reduce((acc, r) => acc + getRowQty(r), 0);
    const remainingQty = () => Math.max(0, selectedQty() - sumAllRowQty());

    // STRICT clamp for a specific row
    function clampRowQty(row, input){
      const desired = Math.max(1, parseInt(input.value || '1', 10));
      const totalOthers = rows().reduce((acc, r) => acc + (r === row ? 0 : getRowQty(r)), 0);
      const maxAllowed = Math.max(1, selectedQty() - totalOthers);
      const clamped = Math.min(desired, maxAllowed);

      if (String(input.value) !== String(clamped)) {
        input.value = String(clamped);
        row.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    function decorateRow(row, { index = 1 } = {}) {
      let head  = row.querySelector('[data-head]');
      let title = head?.querySelector('.print-row__title');

      if (!head) {
        head = document.createElement('div');
        head.className = 'print-row__head';
        head.setAttribute('data-head', '');
        title = document.createElement('div');
        title.className = 'print-row__title';
        head.appendChild(title);

        const removeBtn = row.querySelector('[data-row-remove]');
        if (removeBtn) {
          removeBtn.classList.add('link');
          removeBtn.style.marginLeft = 'auto';
          head.appendChild(removeBtn);
        }
        row.insertBefore(head, row.firstChild);
      } else if (!title) {
        title = document.createElement('div');
        title.className = 'print-row__title';
        head.insertBefore(title, head.firstChild);
      }

      let body = row.querySelector('[data-body]');
      if (!body) {
        body = document.createElement('div');
        body.setAttribute('data-body', '');
        Array.from(row.children).forEach((el) => {
          if (el !== head && !el.hasAttribute('data-body')) body.appendChild(el);
        });
        row.appendChild(body);
      }
      body.hidden = false;

      function refreshHead() {
        let label = '';
        if (printMode === 'with_select') {
          const tab = rowActiveTab(row);
          if (tab === 'team') {
            label = String(row.querySelector('[data-player]')?.value || '').trim();
          } else {
            const n  = String(row.querySelector('[data-print-number]')?.value || '')
                        .replace(/^0+(?=\d)/, '').trim();
            const nm = String(row.querySelector('[data-print-name]')?.value || '')
                        .trim().toUpperCase();
            if (n || nm) label = `${n}${(n && nm) ? ' - ' : ''}${nm}`;
          }
        } else {
          label = String(row.querySelector('[data-print-free]')?.value || '').trim();
        }
        const qty = getRowQty(row);
        const baseLabel = (root.dataset.printLabel || 'Trykk nr.');
        title.textContent = label ? `${label} × ${qty}` : `${baseLabel} ${index} × ${qty}`;
      }

      row.addEventListener('input',  refreshHead);
      row.addEventListener('change', refreshHead);
      refreshHead();
    }

    function addRow({initialQty = 1} = {}) {
      if (!tpl || !rowsEl) return;
      if (remainingQty() <= 0) return;

      const fragment = document.importNode(tpl.content, true);
      const row = fragment.querySelector('[data-row]') || fragment.firstElementChild;

      const firstTab = row.querySelector('.print-tab__button[data-tab="custom"]');
      if (firstTab) firstTab.classList.add('print-tab__button--active');
      row.querySelectorAll('.print-panel').forEach(p => { p.hidden = p.dataset.panel !== 'custom'; });

      setRowQty(row, Math.min(initialQty, Math.max(1, remainingQty())));
      rowsEl.appendChild(fragment);

      const list = rows();
      const last = list[list.length - 1];
      decorateRow(last, {index: list.length});

      syncAddBtnState();
      updateTotals();
      // const firstInput = last.querySelector('[data-print-number],[data-print-name],[data-player],[data-print-free]');
      // firstInput?.focus();
    }

    function syncAddBtnState(){
      if (!addBtn) return;
      addBtn.disabled = sumAllRowQty() >= selectedQty();
      addBtn.classList.toggle('is-disabled', addBtn.disabled);
    }

    // totals
    function updateTotals() {
      const baseC  = baseUnitCents();
      const addonC = addonUnitCents();

      if (basePriceEl && baseC >= 0) basePriceEl.textContent = moneyFormatter(baseC);
      if (addonPriceEl && addonC >= 0) addonPriceEl.textContent = moneyFormatter(addonC);

      const selQty    = selectedQty();
      const hasPrints = !!(toggle && toggle.checked);

      const addonQty = hasPrints ? sumAllRowQty() : 0;

      const baseSubtotal  = baseC  * selQty;
      const addonSubtotal = addonC * addonQty;
      const total         = baseSubtotal + addonSubtotal;

      addonPriceEl?.parentElement?.classList.toggle('muted', addonQty === 0);

      if (totalEl) totalEl.textContent = moneyFormatter(total);
      if (baseQtyDisplay)  baseQtyDisplay.textContent  = selQty;
      if (baseSubtotalEl)  baseSubtotalEl.textContent  = moneyFormatter(baseSubtotal);
      if (addonQtyDisplay) addonQtyDisplay.textContent = addonQty;
      if (addonSubtotalEl) addonSubtotalEl.textContent = moneyFormatter(addonSubtotal);

      syncAddBtnState();
    }

    // UI events
    if (repeater && rows().length === 0) addRow({ initialQty: 1 });

    addBtn?.addEventListener('click', () => addRow({ initialQty: 1 }));

    rowsEl?.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-row-remove]');
      if (!btn) return;
      e.preventDefault();

      const row = btn.closest('[data-row]');
      if (!row) return;

      row.remove();

      if (rows().length === 0) addRow({ initialQty: 1 });
      rows().forEach((r, i) => {
        const title = r.querySelector('.print-row__title');
        if (title && !rowHasContent(r)) {
          const baseLabel = (root.dataset.printLabel || 'Trykk nr.');
          title.textContent = `${baseLabel} ${i+1} × ${getRowQty(r)}`;
        }
      });
      syncAddBtnState();
      updateTotals();
    });

    // tabs
    rowsEl?.addEventListener('click', (e) => {
      const btn = e.target.closest('.print-tab__button'); if (!btn) return;
      const row = btn.closest('[data-row]');
      row.querySelectorAll('.print-tab__button').forEach(b => b.classList.remove('print-tab__button--active'));
      btn.classList.add('print-tab__button--active');
      const tab = btn.dataset.tab;
      row.querySelectorAll('.print-panel').forEach(p => { p.hidden = (p.dataset.panel !== tab); });
      hideError();
      updateTotals();
    });

    // input in rows (auto enable checkbox; clamp; totals)
    rowsEl?.addEventListener('input', (e) => {
      const t = e.target;
      const row = t.closest('[data-row]'); if (!row) return;

      if (t.matches('[data-qty]')) {
        clampRowQty(row, t);
      }

      const isPrintField = t.matches('[data-print-number],[data-print-name],[data-player],[data-print-free]');
      if (isPrintField && toggle && !toggle.checked) toggle.checked = true;

      updateTotals();
      hideError();
    });
    rowsEl?.addEventListener('change', (e) => {
      const t = e.target;
      const row = t.closest('[data-row]'); if (!row) return;
      if (t.matches('[data-qty]')) clampRowQty(row, t);
      updateTotals();
      hideError();
    });

    // main qty
    const onQtyChange = () => {
      let total = sumAllRowQty();
      const sel = selectedQty();
      if (total > sel) {
        rows().reverse().forEach(r => {
          if (total <= sel) return;
          const el = r.querySelector('[data-qty]');
          const val = Math.max(1, parseInt(el.value || '1', 10));
          const excess = total - sel;
          const newVal = Math.max(1, val - excess);
          if (newVal !== val) {
            el.value = String(newVal);
            r.dispatchEvent(new Event('input', { bubbles: true }));
          }
          total = sumAllRowQty();
        });
      }
      syncAddBtnState();
      updateTotals();
    };
    qtyInput?.addEventListener('input', onQtyChange);
    qtyInput?.addEventListener('change', onQtyChange);

    // checkbox
    toggle?.addEventListener('change', () => { if (!toggle.checked) hideError(); updateTotals(); });

    // validation on submit
    function validateAllRows() {
      if (!toggle || !toggle.checked) { hideError(); return true; }
      const list = rows();
      if (list.length === 0) { showError(printRequiredMsg); return false; }

      for (const r of list) {
        const body = r.querySelector('[data-body]');
        if (printMode === 'with_select') {
          const tab = rowActiveTab(r);
          if (tab === 'team') {
            const sel = r.querySelector('[data-player]');
            if (!String(sel?.value || '').trim()) { body.hidden=false; showError(printRequiredMsg); sel?.focus(); return false; }
          } else {
            const num = r.querySelector('[data-print-number]');
            const nm  = r.querySelector('[data-print-name]');
            const nVal  = String(num?.value || '').replace(/^0+(?=\d)/,'').trim();
            const nmVal = String(nm?.value  || '').trim();
            const okAny = !!(nVal || nmVal);

            if (!okAny) {
              body.hidden = false;
              showError(printRequiredMsg);
              (num || nm)?.focus();
              return false;
            }
          }
        } else {
          const free = r.querySelector('[data-print-free]');
          if (!String(free?.value || '').trim()) { body.hidden=false; showError(printRequiredMsg); free?.focus(); return false; }
        }
      }
      hideError();
      return true;
    }
    const submitBtn =
      root.querySelector('button.product-form__submit[name="add"]') ||
      root.querySelector('button[type="submit"][name="add"]');
    function blockIfInvalid(e){
      if (!validateAllRows()){ e.preventDefault(); e.stopPropagation(); if (typeof e.stopImmediatePropagation==='function') e.stopImmediatePropagation(); return false; }
      return true;
    }
    if (submitBtn){ submitBtn.addEventListener('click', blockIfInvalid, true); submitBtn.addEventListener('click', blockIfInvalid); }

    // variant sync
    function applyVariantId(vid) {
      if (!vid) return;
      const v = findVariantById(vid);
      if (v && basePriceEl) basePriceEl.dataset.baseCents = String(v.price || 0);

      const baseVariantTitleEl = root.querySelector('.base-product__variant');
      if (baseVariantTitleEl) baseVariantTitleEl.textContent = v?.title || '';

      const formVariantInput = root.querySelector('input.product-variant-id[name="id"]') ||
                               root.querySelector('form input[name="id"]');
      if (formVariantInput && String(formVariantInput.value) !== String(vid)) formVariantInput.value = String(vid);

      if (repeater) { repeater.dataset.baseVariantId = String(vid); repeater.dataset.baseSku = getSkuById(vid) || ''; }

      try {
        const img = root.querySelector('.base-product__image');
        const src = v?.featured_image?.src || v?.featured_media?.src || '';
        if (img && src) {
          const src90  = src.replace(/(\.(jpe?g|png|webp|gif))(\?.*)?$/i, '_90x$1');
          const src140 = src.replace(/(\.(jpe?g|png|webp|gif))(\?.*)?$/i, '_140x$1');
          img.src = src140; img.srcset = `${src90} 90w, ${src140} 140w`;
        }
      } catch(_) {}
      updateTotals();
    }
    const variantInput = getVariantInput();
    variantInput?.addEventListener('input',  () => applyVariantId(variantInput.value));
    variantInput?.addEventListener('change', () => applyVariantId(variantInput.value));
    scope.addEventListener('variant:change', (e) => { const vid = e?.detail?.variant?.id; if (vid) applyVariantId(vid); });
    let lastVid=null; setInterval(()=>{ const cur=getVariantInput()?.value; if(cur && cur!==lastVid){ lastVid=cur; applyVariantId(cur);} },400);

    // reset on modal open
    function resetAddon(){
      // clear UI
      hideError();
      if (toggle) toggle.checked = false;
      if (rowsEl) {
        rowsEl.innerHTML = '';
        addRow({ initialQty: 1 });
      }
      updateTotals();
    }
    const modalEl = root.closest('modal-dialog');
    if (modalEl && modalEl.id) {
      // click on openers
      document.querySelectorAll(`[data-modal="#${modalEl.id}"]`).forEach(opener => {
        opener.addEventListener('click', () => { resetAddon(); }, { capture: true });
      });
      // attribute changes (programmatic open)
      const mo = new MutationObserver(() => {
        const isOpen = modalEl.hasAttribute('open') || modalEl.classList.contains('active') || !modalEl.hidden;
        if (isOpen) resetAddon();
      });
      mo.observe(modalEl, { attributes: true, attributeFilter: ['open','class','hidden','style'] });
    }

    function getRowPrintText(row){
      if (printMode === 'with_select') {
        const tab = rowActiveTab(row);
        if (tab === 'team') {
          return String(row.querySelector('[data-player]')?.value || '').trim();
        } else {
          const n  = String(row.querySelector('[data-print-number]')?.value || '').replace(/^0+(?=\d)/,'').trim();
          const nm = String(row.querySelector('[data-print-name]')?.value || '').trim().toUpperCase();
          if (!n && !nm) return '';
          return `${n}${(n && nm) ? ' - ' : ''}${nm}`;
        }
      } else {
        return String(row.querySelector('[data-print-free]')?.value || '').trim();
      }
    }

    repeater.buildCartItems = () => {
      const items = [];

      const baseVariantId   = Number(repeater.dataset.baseVariantId || currentVariantId());
      const parentSku       = repeater.dataset.baseSku || getSkuById(baseVariantId) || '';
      const addonVariantId  = Number(repeater.dataset.addonVariantId || 0);

      const bundleUidBase = Date.now().toString(36);

      rows().forEach((row, idx) => {
        const qty  = getRowQty(row);
        const text = getRowPrintText(row);
        if (!text || qty <= 0 || !addonVariantId) return;

        const uid = `${bundleUidBase}-${idx}`;

        items.push({
          id: baseVariantId,
          quantity: qty,
          properties: {
            '_bundle_uid': uid,
            '_bundle_role': 'parent',
          }
        });

        items.push({
          id: addonVariantId,
          quantity: qty,
          properties: {
            '_bundle_uid': uid,
            '_bundle_role': 'child',
            '_parent_sku': parentSku,
            'Print': text,
          }
        });
      });

      const selected = Math.max(1, parseInt(
        (scope.querySelector('.quantity__input[name="quantity"]')?.value) || '1', 10
      ));
      const printedQty = items
        .filter(it => it.id === baseVariantId)
        .reduce((s,it)=> s + (Number(it.quantity)||0), 0);

      const leftover = Math.max(0, selected - printedQty);
      if (leftover > 0) {
        items.push({ id: baseVariantId, quantity: leftover });
      }

      return items;
    };

    scope.__printRepeater = repeater;

    // initial
    applyVariantId(currentVariantId());
    updateTotals();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-form').forEach(setupPrintAddon);
  });
})();
